import { Component, OnInit, Renderer2, Inject } from '@angular/core';

@Component({
  selector: 'app-internal-server-error',
  templateUrl: './internal-server-error.component.html',
  styleUrls: ['../error.component.scss']
})
export class InternalServerErrorComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
